import React, { createContext, useState, useEffect } from 'react';
import api from '../api';

export const MonthContext = createContext();

export const MonthProvider = ({ children }) => {
  const now = new Date();
  const currentMonthStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
  
  const [selectedMonth, setSelectedMonth] = useState(currentMonthStr);
  const [monthsStatus, setMonthsStatus] = useState({});

  useEffect(() => {
    // Fetch initial month status
    api.get('/months/status')
      .then(res => {
        setMonthsStatus(res.data || {});
        // Optionally, default to the last non-closed month
        const options = [];
        for (let i = -3; i < 12; i++) {
          const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
          options.push(`${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`);
        }
        let defaultMonth = currentMonthStr;
        for (const m of [...options].reverse()) {
          if (!res.data[m]) {
            defaultMonth = m;
            break;
          }
        }
        setSelectedMonth(defaultMonth);
      })
      .catch(err => console.error("Error fetching month statuses:", err));
  }, []);

  return (
    <MonthContext.Provider value={{ selectedMonth, setSelectedMonth, monthsStatus, setMonthsStatus }}>
      {children}
    </MonthContext.Provider>
  );
};
